let installed = false;
let usingKeyboard = false;

export const FOCUS_VISIBLE_CLASS = 'rr-focus-visible';

export function installFocusVisibleClass(): () => void {
  if (typeof document === 'undefined' || installed) return () => {};
  installed = true;

  const onKey = () => {
    if (!usingKeyboard) {
      usingKeyboard = true;
      document.body.classList.add(FOCUS_VISIBLE_CLASS);
    }
  };
  const onPointer = () => {
    if (usingKeyboard) {
      usingKeyboard = false;
      document.body.classList.remove(FOCUS_VISIBLE_CLASS);
    }
  };

  window.addEventListener('keydown', onKey, true);
  window.addEventListener('mousedown', onPointer, true);
  window.addEventListener('pointerdown', onPointer, true);
  window.addEventListener('touchstart', onPointer, true);

  return () => {
    installed = false;
    window.removeEventListener('keydown', onKey, true);
    window.removeEventListener('mousedown', onPointer, true);
    window.removeEventListener('pointerdown', onPointer, true);
    window.removeEventListener('touchstart', onPointer, true);
    document.body.classList.remove(FOCUS_VISIBLE_CLASS);
  };
}

export function isFocusVisible(el?: Element | null): boolean {
  if (typeof document === 'undefined') return false;
  if (!usingKeyboard) return false;
  if (!el) return document.body.classList.contains(FOCUS_VISIBLE_CLASS);
  return el === document.activeElement && usingKeyboard;
}
